// import React from "react";
// import { useSelector } from "react-redux";
// import { AddBtn } from "@commonComponents/AddBtn";
// import { FormTitle } from "@commonComponents/FormTitle";
// import { selectDepartureTransportDS } from "@EUForms/selectors";

// const DepartureTransportDetail = ({translate,renderForm,addItem,tableName="departureTransportMeansList",updateItem:onChange,saveItem:onBlur,onSelect}) => {

//     const dataSource =useSelector(selectDepartureTransportDS);
//     return (
//     <div className="grow mb-2 col formContainer">
//     <FormTitle className="formTitle" textAlign="start" boxNumber="7/7" title="Departure Transport Means" />
//     {dataSource.length>0 ? renderForm({onChange,onBlur,dataSource:dataSource[0],onSelect,tableName,translate}) : <AddBtn style={{width:"max-content"}} onClick={()=>addItem(tableName)} text={translate("ADD")} />}
//     </div>
//     )

// }

// export default React.memo(DepartureTransportDetail)

import React from "react";
import List from "@commonComponents/List";
import { selectMotTypeList } from "@EUForms/selectors";
import { useSelector } from "react-redux";

const DepartureTransportDetail = ({ dataSource, renderForm, ...rest }) => {
  let motTypeList = useSelector(selectMotTypeList)
  const renderItem = (item) => {
    // let motTypeListUpdated = motTypeList?.filter((motType) => {
    //   return ['1','2','3','4','8'].includes(item?.modeOfTransport)
    //     ? motType.value.startsWith(item?.modeOfTransport) 
    //     : true
    // })
    return renderForm({
      dataSource: item,
      key: item.id,
      motTypeList,
      // motTypeList:motTypeListUpdated,
      ...rest
    })
  }
  return <List className="responsiveGridCss" dataSource={dataSource} renderItem={renderItem} />

}

export default DepartureTransportDetail
